/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetShiftChangeProposalsRequest} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'
import {GetShiftChangeProposalsResponse} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'


export const getShiftChangeProposals = (request: GetShiftChangeProposalsRequest, options?: CashRequestOptions) => post<GetShiftChangeProposalsRequest, GetShiftChangeProposalsResponse>("/2.0/cash/get-shift-change-proposals", request, {...options, rejectOnError: true })